import { Drawer } from '@bolteu/clay-react';
import { useBreakpointUp } from '@provider-portal/design-common/clay/hooks/useBreakpoint';

import { NavBarLogo } from './NavBarLogo';
import { NavBarMenu, NavBarMenuItem } from './NavBarMenu';
import { NavBarVenueSelector, NavBarVenueSelectorProps } from './NavBarVenueSelector';

export interface NavBarDrawerProps {
  isMobileOpen: boolean;
  drawerWidth: number;
  menuItems: NavBarMenuItem[];
  venueSelector: NavBarVenueSelectorProps;
  onDrawerToggle: () => void;
  onMenuItemClick?: (menuItem: NavBarMenuItem) => void;
  onSelectorOpen?: () => void;
  onSearchPerformed?: (searchQuery: string, resultsCount: number, searchCount: number) => void;
}

export function NavBarDrawer({
  isMobileOpen,
  drawerWidth,
  menuItems,
  venueSelector,
  onDrawerToggle,
  onMenuItemClick,
  onSelectorOpen,
  onSearchPerformed,
}: NavBarDrawerProps) {
  const isMobileView = !useBreakpointUp('md');

  const content = (
    <div className="flex flex-col gap-2">
      <NavBarLogo />
      {!isMobileView && (
        <NavBarVenueSelector
          parentName={venueSelector.parentName}
          storeName={venueSelector.storeName}
          selectedStoreId={venueSelector.selectedStoreId}
          stores={venueSelector.stores}
          storeAvailabilities={venueSelector.storeAvailabilities}
          storeAvailabilitiesLoading={venueSelector.storeAvailabilitiesLoading}
          onProviderSelect={venueSelector.onProviderSelect}
          showAddVenueButton={venueSelector.showAddVenueButton}
          onAddVenue={venueSelector.onAddVenue}
          onSelectorOpen={onSelectorOpen}
          onSearchPerformed={onSearchPerformed}
        />
      )}
      <NavBarMenu menuItems={menuItems} onMenuItemClick={onMenuItemClick} />
    </div>
  );

  if (!isMobileView) {
    return (
      <div
        className="fixed top-0 left-0 z-[1200] flex h-full flex-col overflow-y-auto [border-right:1px_solid_var(--color-border-separator)] bg-layer-floor-1 px-2 py-5"
        style={{ width: drawerWidth + 18 }}
      >
        {content}
      </div>
    );
  }

  return (
    <Drawer.Root
      open={isMobileOpen}
      onOpenChange={(open) => {
        if (!open) {
          onDrawerToggle();
        }
      }}
      swipeDirection="left"
    >
      <Drawer.Portal>
        <Drawer.Backdrop />
        <Drawer.Viewport>
          <Drawer.Popup
            className="rounded-none [border-right:1px_solid_var(--color-border-separator)] px-2 py-5 shadow-none [--drawer-gap:0px]"
            style={{ width: drawerWidth }}
          >
            {content}
          </Drawer.Popup>
        </Drawer.Viewport>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
